import { notificationTypes } from "./notificationTypes";

export const eventTopicRredirectRules = [
    {
        topic: notificationTypes.userCreated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/users`;
            navigate(route);
        },
    },
    {
        topic: notificationTypes.userUpdated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/users/${payload?.id ? payload.id : ""}`;
            navigate(route);
        },
    },
    {
        topic: notificationTypes.partRequestCreated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/requests`;
            navigate(route);
        },
    },
    {
        topic: notificationTypes.partRequestCreated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/requests/${payload?.id ? payload.id : ""}`;
            navigate(route);
        },
    },
    {
        topic: notificationTypes.partOfferCreated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/requests`;
            navigate(route);
        },
    },
    {
        topic: notificationTypes.partOfferUpdated,
        handleRedirect: (payload, navigate) => {
            if (!navigate) return;
            const route = `/admin/offers/${payload?.id ? payload.id : ""}`;
            navigate(route);
        },
    },
];
